import { MarketHeaderSkeleton } from '@/components/market/market-header-skeleton';
import { Skeleton } from '@/components/ui/app-skeleton';
import { CHART_HEIGHT_CLASS } from '@/config/chart';
import { DETAIL_SIDEBAR_W_CLASS } from '@/lib/ui/layout';
import { cn } from '@/lib/ui/utils';

export default function MarketDetailLoading(): React.ReactNode {
  return (
    <div>
      <div className="flex gap-6">
        {/* Left column — header + chart panel, outcomes overview, tabbed section */}
        <div className="flex min-w-0 flex-1 flex-col gap-4">
          {/* Header — mirrors MarketHeader's desktop row: size-24 cover +
              (title · meta) column. ~103px to match the live header. */}
          <MarketHeaderSkeleton />

          {/* Price chart — canvas at the canonical CHART_HEIGHT_CLASS, with the
              mode-toggle + interval row BELOW it (not pills above). */}
          <div className="flex flex-col gap-3">
            <Skeleton className={cn(CHART_HEIGHT_CLASS, 'w-full rounded-card')} />
            <div className="flex items-center justify-between gap-2">
              <Skeleton className="h-9 w-40 rounded-pill" />
              <Skeleton className="h-9 w-28 rounded-pill" />
            </div>
          </div>

          {/* Outcomes overview — one simple block (matches the live card's
              ~132px height); the column gap-4 owns the spacing. */}
          <Skeleton className="h-32 w-full rounded-card" />

          {/* Tabbed section — one simple block (matches the live ~204px). */}
          <Skeleton className="h-52 w-full rounded-card" />
        </div>

        {/* Right column — desktop only, sticky trade form + prize pool + rewards */}
        <div
          className={cn(
            DETAIL_SIDEBAR_W_CLASS,
            'hidden shrink-0 flex-col gap-3 self-start lg:flex',
          )}
        >
          <Skeleton className="h-96 w-full rounded-card" />
          <Skeleton className="h-32 w-full rounded-card" />
          <Skeleton className="h-32 w-full rounded-card" />
        </div>
      </div>
    </div>
  );
}
